import { mergeAttributes, Node } from '@tiptap/core';
import { InputRule } from '@tiptap/core';

export const Attribute = Node.create({
  name: 'attribute',

  priority: 101,

  addOptions() {
    return {
      HTMLAttributes: {},
      renderText({ node }) {
        const tooltip = node.attrs.tooltip ? ` (${node.attrs.tooltip})` : '';
        return `[${node.attrs.content}]${tooltip}`;
      },
    };
  },

  group: 'inline',

  inline: true,

  selectable: false,

  atom: true,

  addAttributes() {
    return {
      content: {
        default: null,
        parseHTML: element => element.getAttribute('data-content'),
        renderHTML: attributes => {
          if (!attributes.content) {
            return {};
          }

          return {
            'data-content': attributes.content,
          };
        },
      },

      tooltip: {
        default: null,
        parseHTML: element => element.getAttribute('data-tooltip'),
        renderHTML: attributes => {
          if (!attributes.tooltip) {
            return {};
          }

          return {
            'data-tooltip': attributes.tooltip,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const tooltip = node.attrs.tooltip || '';
    const baseAttributes = {
      'data-type': this.name,
      'data-content': node.attrs.content,
      class: 'attribute-pill',
    };

    // Add tooltip attributes if tooltip exists
    if (tooltip) {
      baseAttributes['data-tooltip'] = tooltip;
      baseAttributes.title = tooltip; // Native browser tooltip
      baseAttributes['aria-label'] = `${node.attrs.content}: ${tooltip}`;
    } else {
      baseAttributes['aria-label'] = node.attrs.content;
    }

    return [
      'span',
      mergeAttributes(
        baseAttributes,
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
      node.attrs.content,
    ];
  },

  renderText({ node }) {
    const tooltip = node.attrs.tooltip ? `(${node.attrs.tooltip})` : '';
    return `[${node.attrs.content}]${tooltip}`;
  },

  addInputRules() {
    return [
      new InputRule({
        find: /\[([^\]]+)\](?:\(([^)]*)\))?\s$/,
        handler: ({ state, range, match }) => {
          const [, content, tooltip] = match;
          const { tr } = state;
          const start = range.from;
          const end = range.to;

          tr.replaceWith(
            start,
            end - 1,
            this.type.create({
              content,
              tooltip: tooltip || null,
            })
          );

          return tr;
        },
      }),
    ];
  },
});
